import "./LoadIndicator.scss"
import { classNames } from "../../helpers/cssClassHelper"
import { LoadIndicator as DxLoadIndicator } from "devextreme-react"

interface LoadIndicatorProps {
    className?: string
    loading?: boolean
    glueToParent?: boolean
}

export default function LoadIndicator(props: LoadIndicatorProps) {
    if (!props.loading) {
        return null
    }

    const className = classNames(
        "load-indicator-overlay",
        props.glueToParent && "glue-to-parent"
    )

    return (
        <div className={className}>
            <div className="load-indicator-container">
                <DxLoadIndicator visible={props.loading}  />
            </div>
        </div>
    )
}